module.exports = __webpack_public_path__ + "img/symbol-roman-left.1fc49ee7.png";